// extracted by mini-css-extract-plugin
module.exports = {"posts":"styles-m__posts---15d9s"};